export const getHelpMenuLink = (language: string) => {
  return `https://help.hotmart.com/${language}/categories/comprei-pela-hotmart-e-preciso-de-ajuda/360003231591`
}

export const PURCHASES_MENU = `https://purchase.hotmart.com/`
